import MainFrame from "../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import AddModal from "./modal";
import { Helmet } from "react-helmet";
import {
  useDeleteUserMutation,
  useGetUsersQuery,
} from "../../app/services/usres.api";
import { getUserName, getUserType } from "../../types/user";
import getImageLink from "../../utils/getImageLink";
import { useState } from "react";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Users() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<{
    page?: number;
    size?: number;
    userName?: string;
    phone?: string;
  }>({});
  const [deleteUser] = useDeleteUserMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      setContent({
        title: " ویرایش کاربر",
        body: <AddModal defaultValue={data?.users?.entities[id]} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن کاربر",
        body: <AddModal />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف کاربر",
        body: (
          <DeleteModal
            handleDelete={() => {
              deleteUser(id)
                .unwrap()
                .then(() => setShow(false))
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }
  const { data, isLoading, isFetching } = useGetUsersQuery(query);
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> کاربران | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="کاربران">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن کاربر
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "نام" },
          { name: "تصویر" },
          { name: "شماره تماس" },
          { name: "نوع کاربری" },
          { name: "کمیسیون" },
          { name: "توضیحات" },
        ]}
        operations={true}
        length={data?.length ?? 0}
        isLoading={isLoading || isFetching}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {data?.users?.ids?.map((id, indx) => {
          const user = data?.users.entities[id];
          return (
            <TableRow hover role="checkbox" tabIndex={-1} key={id}>
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell width="15%">{getUserName(user)}</Cell>
              <Cell>
                {user.profile ? (
                  <img
                    width={"10%"}
                    height={"10%"}
                    alt="profile"
                    src={getImageLink(user.profile)}
                  />
                ) : (
                  "not set"
                )}
              </Cell>
              <Cell>{user.phone}</Cell>
              <Cell>{getUserType(user)}</Cell>
              <Cell>{user?.commision ?? 0}</Cell>
              <Cell>{user?.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton onClick={() => handleOpenModal("delete", id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Users);
